<template>
  <svg id="gezondheid" viewBox="0 0 64 64">
    <path
      d="M61.6,20.7c0,0,0,0.1,0,0.1c0,0.1,0,0.3-0.1,0.6c-0.3,1.3-0.8,2.6-1.4,3.8c0,0,0,0.1,0,0.1H37
                c-0.4,0-0.7,0.2-0.8,0.6l-3.2,14L25,15.1c-0.1-0.3-0.4-0.5-0.7-0.5c-0.3,0-0.6,0.2-0.7,0.5l-4.2,12h-14c-0.4-0.7-0.7-1.3-1-1.9
                C3.7,24,3.3,22.7,3,21.4c-0.1-0.3-0.1-0.5-0.1-0.5c0,0,0-0.1,0-0.1c-0.2-0.9-0.2-1.7-0.2-2.6c0-8.1,6.6-14.6,14.6-14.6
                C24,3.6,30,8.4,31.5,15c0.1,0.4,0.4,0.6,0.8,0.6c0.4,0,0.7-0.3,0.8-0.6c1.5-6.6,7.5-11.4,14.3-11.4c8.1,0,14.6,6.6,14.6,14.6
                C61.9,19,61.8,19.9,61.6,20.7 M32.2,60.2C19.3,46.6,10.6,36,6.2,28.6h13.7c0.3,0,0.6-0.2,0.7-0.5l3.6-10.3L32.5,43
                c0.1,0.3,0.4,0.5,0.7,0.5c0,0,0,0,0,0c0.3,0,0.6-0.3,0.7-0.6l3.7-16.1h21.6C55.3,34.2,46.3,45.4,32.2,60.2 M47.3,2
                c-6.6,0-12.6,4.2-15,10.2C29.8,6.2,23.9,2,17.2,2C8.3,2,1.1,9.3,1.1,18.2c0,0.9,0.1,1.8,0.2,2.7c0,0,0,0,0,0c0,0,0,0.3,0.2,0.8
                c0.3,1.5,0.9,2.8,1.5,4.1c3.5,7.6,12.9,19.4,28.7,36c0.1,0.2,0.3,0.2,0.6,0.2c0,0,0.1,0,0.1,0c0.2,0,0.3-0.1,0.5-0.2
                c15.8-16.6,25.2-28.4,28.7-36c0.7-1.3,1.2-2.7,1.6-4.1c0.1-0.5,0.2-0.8,0.2-0.8c0,0,0,0,0,0c0.2-0.9,0.2-1.8,0.2-2.7
                C63.4,9.3,56.2,2,47.3,2"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconGezondheid extends Vue {}
</script>
